import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import AnnouncementForm from '../AnnouncementForm';

const AnnouncementFormModal = ({
  form,
  isOpen,
  onClose,
  status,
  courses,
  getCourseOffers,
  courseOffers,
  trainers,
  getTrainers,
  onSubmit,
  title,
  type,
  initialValues,
  courseOfferChangeDisabled,
}) => (
  <Modal title={title} visible={isOpen} onCancel={onClose} footer={null}>
    <AnnouncementForm
      type={type}
      initialValues={initialValues}
      onSubmit={onSubmit}
      status={status}
      courses={courses}
      getCourseOffers={getCourseOffers}
      courseOffers={courseOffers}
      trainers={trainers}
      getTrainers={getTrainers}
      form={form}
      courseOfferChangeDisabled={courseOfferChangeDisabled}
    />
  </Modal>
);

AnnouncementFormModal.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  form: PropTypes.any, //change
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  status: PropTypes.shape({}),
  courses: PropTypes.array,
  getCourseOffers: PropTypes.func.isRequired,
  coursesOffers: PropTypes.arrayOf(
    PropTypes.shape({
      wave: PropTypes.string.isRequired,
      courseOfferId: PropTypes.string.isRequired,
    })
  ),
  trainers: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    })
  ),
  getTrainers: PropTypes.func,
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  courseOfferChangeDisabled: PropTypes.bool,
};

AnnouncementFormModal.defaultProps = {
  coursesOffers: [],
  courses: [],
  trainers: [],
  initialValues: {},
};

export default AnnouncementFormModal;
